<template>
  <div class="supply-list">
    <van-search
      autocomplete="off"
      v-model="searchForm.orderNo"
      placeholder="请输入订单号查询"
      @search="onSearch"
    >
      <template #right-icon>
        <van-icon name="filter-o" @click="showFilter = true" />
      </template>
    </van-search>

    <van-tabs v-model="activeTab" color="#4c9673" title-active-color="#4c9673" @change="onTabChange">
      <van-tab
        v-for="tab in statusTabs"
        :key="tab.key"
        :title="tabTitle(tab)"
        :name="tab.key"
      />
    </van-tabs>

    <div ref="scrollList" class="list-scroll">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已显示全部"
        @load="getList(true)"
      >
        <div
          v-for="item in tableData"
          :key="item.id"
          class="order-card"
          @click="goDetail(item)"
        >
          <div class="order-card__head">
            <div class="order-card__no">订单号：{{ item.orderNo || '-' }}</div>
            <div class="order-card__status" :class="'status-' + item.status">
              {{ item.statusDesc || '-' }}
            </div>
          </div>

          <div class="order-card__merch">
            <span>{{ item.merchName || '-' }}</span>
            <span v-if="item.phone" class="order-card__phone">{{ item.phone }}</span>
          </div>

          <div v-if="firstItem(item)" class="order-card__product">
            <div class="product-name">
              {{ productDisplayName(firstItem(item)) }}
            </div>
            <div v-if="firstItem(item).spec" class="product-line">
              规格：{{ firstItem(item).spec }}
            </div>
            <div v-if="firstItem(item).barCode" class="product-line">
              69条码：{{ firstItem(item).barCode }}
            </div>
            <div class="product-line product-price">
              {{ formatAmount(firstItem(item).actualUnitPrice) }}
              <template v-if="firstItem(item).quantity">
                x {{ firstItem(item).quantity }}
              </template>
            </div>
            <div v-if="(item.items || []).length > 1" class="product-more">
              共 {{ item.items.length }} 件商品, 点击查看详情
            </div>
          </div>

          <div class="order-card__footer">
            <div class="footer-left">
              <div class="amount">实付 {{ formatAmount(item.payAmount) }}</div>
              <div class="meta">
                <span :class="item.pulled ? 'pulled-yes' : 'pulled-no'">
                  {{ item.pulled ? '已发起' : '未发起' }}
                </span>
                <span class="time">{{ item.createTime || '-' }}</span>
              </div>
            </div>
            <div v-if="canPull(item)" class="footer-actions" @click.stop>
              <van-button
                size="small"
                type="primary"
                color="#4c9673"
                @click="goInbound(item)"
              >
                发起入库
              </van-button>
            </div>
          </div>
        </div>
      </van-list>
    </div>

    <!-- 筛选弹层 -->
    <van-popup v-model="showFilter" position="right" :style="{ width: '80%', height: '100%' }">
      <div class="filter-panel">
        <div class="filter-title">筛选</div>
        <van-cell-group>
          <van-field
            v-model="filterForm.productName"
            label="商品名称"
            placeholder="请输入商品名称"
            clearable
          />
          <van-field
            v-model="filterForm.barCode"
            label="69条形码"
            placeholder="请输入69条形码"
            clearable
          />
          <van-field
            v-model="filterForm.startTime"
            label="开始日期"
            placeholder="请选择"
            readonly
            clickable
            @click="openDatePicker('startTime')"
          />
          <van-field
            v-model="filterForm.endTime"
            label="结束日期"
            placeholder="请选择"
            readonly
            clickable
            @click="openDatePicker('endTime')"
          />
          <van-field
            :value="hasAfterSaleText"
            label="是否有售后"
            placeholder="全部"
            readonly
            clickable
            @click="showAfterSalePicker = true"
          />
        </van-cell-group>
        <div class="filter-actions">
          <van-button block @click="resetFilter">重置</van-button>
          <van-button block type="primary" color="#4c9673" @click="confirmFilter">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>

    <DateTimePicker
      value-format="yyyy-MM-dd"
      :showPicker="showDatePicker"
      @confirm="onDateConfirm"
      @cancel="showDatePicker = false"
    />

    <van-popup v-model="showAfterSalePicker" position="bottom" round>
      <van-picker
        show-toolbar
        title="是否有售后"
        :columns="afterSaleColumns"
        @cancel="showAfterSalePicker = false"
        @confirm="onAfterSaleConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  queryWholesaleOrder,
  statusCount,
} from '../../../service/api/purchase/supply'
import DateTimePicker from '../../../components/dateTimePicker.vue'

const STATUS_FINISHED = 4

export default {
  name: 'supply-chain',
  components: {
    DateTimePicker,
  },
  data() {
    return {
      loading: false,
      finished: false,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      tableData: [],
      activeTab: 'all',
      searchForm: {
        orderNo: '',
      },
      filterForm: {
        productName: '',
        barCode: '',
        startTime: '',
        endTime: '',
        hasAfterSale: undefined,
      },
      tabCounts: {
        all: 0,
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
      statusTabs: [
        { key: 'all', label: '全部' },
        { key: '0', label: '待付款', status: 0 },
        { key: '1', label: '待发货', status: 1 },
        { key: '2', label: '配送中', status: 2 },
        { key: '3', label: '待收货', status: 3 },
        { key: '4', label: '已完成', status: 4 },
        { key: '5', label: '已关闭', status: 5 },
      ],
      showFilter: false,
      showDatePicker: false,
      dateField: '',
      showAfterSalePicker: false,
      afterSaleColumns: [
        { text: '全部', value: undefined },
        { text: '有', value: true },
        { text: '无', value: false },
      ],
      // 列表滚动位置（配合 keep-alive，离开前记录、返回后恢复）
      listScrollTop: 0,
    }
  },
  computed: {
    hasAfterSaleText() {
      if (this.filterForm.hasAfterSale === true) return '有'
      if (this.filterForm.hasAfterSale === false) return '无'
      return ''
    },
  },
  mounted() {
    // keep-alive 命中时不会重复 mounted；仅首次进入拉数
    if (!this.tableData.length) {
      this.loadTabCounts()
      this.onSearch()
    }
  },
  activated() {
    this.applyPulledOrder()
    // 等页面显示后再恢复滚动
    this.$nextTick(() => {
      const el = this.$refs.scrollList
      if (el) el.scrollTop = this.listScrollTop
    })
  },
  beforeRouteLeave(to, from, next) {
    // 必须在离开前存：deactivated 时 DOM 的 scrollTop 往往已是 0
    const el = this.$refs.scrollList
    if (el) this.listScrollTop = el.scrollTop || 0
    next()
  },
  methods: {
    /** 入库成功返回时，局部更新对应订单的发起状态 */
    applyPulledOrder() {
      const orderNo = sessionStorage.getItem('supply-pulled-order-no')
      if (!orderNo) return
      const item = this.tableData.find((row) => row.orderNo === orderNo)
      if (item) this.$set(item, 'pulled', true)
      this.loadTabCounts()
      sessionStorage.removeItem('supply-pulled-order-no')
    },
    tabTitle(tab) {
      const count = this.tabCounts[tab.key] ?? 0
      return `${tab.label}(${count})`
    },
    firstItem(row) {
      const items = row.items || []
      return items.length ? items[0] : null
    },
    productDisplayName(item) {
      if (!item) return '-'
      const brand = item.brandName ? `【${item.brandName}】` : ''
      return brand + (item.productName || '-')
    },
    formatAmount(amount) {
      if (amount === null || amount === undefined || amount === '') return '-'
      return `¥${Number(amount).toFixed(2)}`
    },
    canPull(row) {
      return row.status === STATUS_FINISHED && !row.pulled
    },
    loadTabCounts() {
      statusCount()
        .then((res) => {
          const data = res.data || {}
          this.tabCounts = {
            all: Number(data.totalCount) || 0,
            0: Number(data.waitPayCount) || 0,
            1: Number(data.waitShipCount) || 0,
            2: Number(data.deliveringCount) || 0,
            3: Number(data.waitReceiveCount) || 0,
            4: Number(data.finishedCount) || 0,
            5: Number(data.closedCount) || 0,
          }
        })
        .catch(() => {})
    },
    buildParams() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        orderNo: this.searchForm.orderNo || undefined,
        productName: this.filterForm.productName || undefined,
        barCode: this.filterForm.barCode || undefined,
      }
      if (this.filterForm.startTime) {
        params.startTime = `${this.filterForm.startTime} 00:00:00`
      }
      if (this.filterForm.endTime) {
        params.endTime = `${this.filterForm.endTime} 23:59:59`
      }
      if (this.filterForm.hasAfterSale === true || this.filterForm.hasAfterSale === false) {
        params.hasAfterSale = this.filterForm.hasAfterSale
      }
      const tab = this.statusTabs.find((item) => item.key === this.activeTab)
      if (tab && tab.status !== undefined) {
        params.status = tab.status
      }
      return params
    },
    onSearch() {
      this.pageIndex = 1
      this.loadTabCounts()
      this.getList()
    },
    onTabChange() {
      this.pageIndex = 1
      this.getList()
    },
    getList(load) {
      if (load) {
        this.pageIndex++
      }
      this.loading = true
      queryWholesaleOrder(this.buildParams())
        .then((res) => {
          this.finished = false
          this.loading = false
          const datas = (res.data && res.data.datas) || []
          if (load) {
            this.tableData = this.tableData.concat(datas)
          } else {
            this.tableData = datas
          }
          this.totalPage = (res.data && res.data.totalPage) || 1
          if (this.pageIndex >= this.totalPage) {
            this.finished = true
          }
        })
        .catch(() => {
          this.loading = false
          this.finished = true
        })
    },
    goInbound(row) {
      this.$router.push({
        path: '/purchase/supplyInbound',
        query: { orderNo: row.orderNo },
      })
    },
    goDetail(row) {
      this.$router.push({
        path: `/purchase/supplyDetail/${row.id}`,
        query: {
          pulled: row.pulled ? '1' : '0',
        },
      })
    },
    openDatePicker(field) {
      this.dateField = field
      this.showDatePicker = true
    },
    onDateConfirm(val) {
      if (val && this.dateField) {
        this.filterForm[this.dateField] = val
      }
      this.showDatePicker = false
    },
    onAfterSaleConfirm(value, index) {
      const item = this.afterSaleColumns[index] || {}
      this.filterForm.hasAfterSale = item.value
      this.showAfterSalePicker = false
    },
    resetFilter() {
      this.filterForm = {
        productName: '',
        barCode: '',
        startTime: '',
        endTime: '',
        hasAfterSale: undefined,
      }
    },
    confirmFilter() {
      this.showFilter = false
      this.onSearch()
    },
  },
}
</script>

<style lang="less" scoped>
* {
  touch-action: pan-y;
}

.supply-list {
  background: #f5f5f5;
  min-height: 100%;
}

::v-deep .van-tabs__wrap {
  position: sticky;
  top: 0;
  z-index: 10;
}

.list-scroll {
  height: calc(100vh - 10rem);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 12px;
}

.order-card {
  margin: 8px 10px 0;
  padding: 12px;
  background: #fff;
  border-radius: 8px;

  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  &__no {
    flex: 1;
    font-size: 14px;
    font-weight: 600;
    color: #262626;
    word-break: break-all;
  }

  &__status {
    flex-shrink: 0;
    margin-left: 8px;
    padding: 2px 8px;
    font-size: 12px;
    border-radius: 10px;
    color: #fff;
    background: #858585;

    &.status-0 {
      background: linear-gradient(83deg, #333, #858585);
    }
    &.status-1,
    &.status-2 {
      background: linear-gradient(83deg, #1677ff, #69b1ff);
    }
    &.status-3 {
      background: linear-gradient(83deg, #fa8c16, #ffc069);
    }
    &.status-4 {
      background: linear-gradient(83deg, #4c9673, #98bf8c);
    }
    &.status-5 {
      background: linear-gradient(83deg, #cf1322, #ff7875);
    }
  }

  &__merch {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: #595959;
    margin-bottom: 8px;
  }

  &__phone {
    color: #8c8c8c;
  }

  &__product {
    padding: 8px 0;
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;

    .product-name {
      font-size: 13px;
      font-weight: 500;
      color: #262626;
      line-height: 1.5;
    }

    .product-line {
      margin-top: 4px;
      font-size: 12px;
      color: #8c8c8c;
    }

    .product-price {
      color: #262626;
      font-size: 13px;
    }

    .product-more {
      margin-top: 6px;
      font-size: 12px;
      color: #1677ff;
    }
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 10px;
    gap: 8px;

    .footer-left {
      flex: 1;
      min-width: 0;
    }

    .amount {
      font-size: 14px;
      font-weight: 600;
      color: #ff4d4f;
    }

    .meta {
      margin-top: 4px;
      font-size: 12px;
      color: #8c8c8c;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .pulled-yes {
      color: #4c9673;
    }

    .pulled-no {
      color: #ff4d4f;
    }

    .footer-actions {
      display: flex;
      flex-shrink: 0;
      gap: 6px;
    }
  }
}

.filter-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;

  .filter-title {
    padding: 16px;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid #f0f0f0;
  }

  .filter-actions {
    margin-top: auto;
    padding: 12px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
}
</style>
